import { Typography } from '@mui/material'
import { Box } from '@mui/system'
import { GridRenderCellParams } from '@mui/x-data-grid-premium'
import CircularStatusBar from 'components/DataGrid/components/CircularStatusBar'
import { FC } from 'react'
import { DensityStyleTypes } from 'types'

interface ProgressCellProps {
  densityStyles: DensityStyleTypes
  params: GridRenderCellParams
}

const ProgressCell: FC<ProgressCellProps> = ({ params, densityStyles }) => {
  const { org_uuid: _org_uuid, isParent, isOrgTask: _isOrgTask } = params?.row ?? {}
  //@ts-ignore
  if (params?.rowNode?.isAutoGenerated) return
  return (
    <Box
      key={'mtb-progress-am'}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      <>
        {isParent ? (
          <CircularStatusBar
            progress={params?.value}
            size={densityStyles.avatarSize}
            fontSize={densityStyles.fontSize}
          />
        ) : (
          <Typography>–</Typography>
        )}
      </>
    </Box>
  )
}
export default ProgressCell
